export const TAG_STATUS = {
  TAGGING: 0,
  PENDING_REVIEW: 1,
  AI_VERIFIED: 2,
  MANUALLY_ADDED: 3,
  FAILED: 4,
} as const;

// `title` is the stored upper-case value the classifier matches on;
// `label` is the cased text to display. Always render `label`.
export type DocumentTag = { uuid: string; title: string; label?: string };

export type DocumentTagReviewDocument = {
  uuid: string;
  name: string;
  file_type: string;
  is_previewable: boolean;
  parent_uuid: string;
  tag_status: number | null;
  tag_status_display: string | null;
  tags: DocumentTag[];
};

export type DocumentTagReviewResponse = {
  documents: DocumentTagReviewDocument[];
  pending_count: number;
};
